import React from 'react';
import { Navigate } from 'react-router-dom';
import { readClientCreds } from '../clientSession';

function ClientPolicyLookup() {
    return <Navigate to={readClientCreds() ? '/client' : '/client/login'} replace />;
}

export default ClientPolicyLookup;
